import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ProductDetails from "./pages/ProductDetails";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Cart from "./pages/Cart";
import CheckoutAddress from "./pages/CheckoutAddress";
import ProductPage from "./pages/ProductPage";
import DashboardPage from "./dashboard/DashboardPage";
import AllProducts from "./pages/Products/AllProducts";
// import CategoryProducts from "./pages/Products/CategoryProducts";
import PaymentPage from "./pages/payment/PaymentPage";
import ForgotPassword from "./pages/ForgotPassword";
import VerifyOTP from "./pages/VerifyOTP";
import ResetPassword from "./pages/ResetPassword";
import ScrollToTop from "./components/ScrollToTop";
import WishlistPage from "./pages/WishlistPage";
import AdminRoute from "./components/AdminRoute";
import SizeGuide from "./pages/SizeGuide";
import ReturnPolicy from "./pages/ReturnPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import 'react-image-lightbox/style.css';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/product/:id" element={<ProductDetails />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/checkout/address" element={<CheckoutAddress />} />
        <Route path="/add-products" element={<ProductPage />} />
        {/* Admin Dashboard */}
        {/* <Route path="/admin" element={<DashboardPage />} /> */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <DashboardPage />
            </AdminRoute>
          }
        />
        <Route path="/size-guide" element={<SizeGuide />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/products" element={<AllProducts />} />
        <Route path="/checkout/payment" element={<PaymentPage />} />

        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<VerifyOTP />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* <Route path="/products/category/:category" element={<CategoryProducts />}/> */}
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
